/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {trackSuccessfulTransferIn} from '../api'

export const useMutationTrackSuccessfulTransferIn = createReactQueryMutationHook('trackSuccessfulTransferIn', trackSuccessfulTransferIn)
